module.exports = __webpack_public_path__ + "32b420895c897e00e40c9091f1f6cc78.png";